'use strict';

export class Lerp {

    // alpha = Math.min((from - currentValue) / distance, 1.0);

    constructor (from, to) {
        this.from = from;
        this.to = to;
    }

    lerp(alpha) {
        return this.from + ( this.to - this.from ) * alpha;
    }

}